<template>
  <div
    class="bekki-new-chat-state d-flex flex-column align-center justify-center ga-4 pa-6 text-center"
    data-cc="bekki-new-chat-state"
  >
    <v-avatar size="56" color="primary" variant="tonal">
      <v-icon icon="huge:bubble-chat-question" size="24" />
    </v-avatar>

    <div class="d-flex flex-column align-center ga-2">
      <h2 class="text-h5">{{ t('widgets.bekki.newChat.title') }}</h2>

      <p class="bekki-new-chat-state__body text-body-2 text-medium-emphasis">
        {{ t('widgets.bekki.newChat.body') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped>
.bekki-new-chat-state {
  min-height: 100%;
}

.bekki-new-chat-state__body {
  max-width: 352px;
}
</style>
